/* OROS Design — Theme JS */

(function () {
  'use strict';

  // ── Nav mobile toggle ──────────────────────────────────────
  var toggle = document.getElementById('nav-toggle');
  var menu   = document.getElementById('nav-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = !menu.hidden;
      menu.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    // Close on anchor click
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Product configurator ───────────────────────────────────
  var swatches  = document.querySelectorAll('.config-swatch');
  var configImg = document.getElementById('config-img');
  var colorLbl  = document.getElementById('config-color-label');
  var variantId = document.getElementById('variant-id');

  if (swatches.length && configImg) {
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {

        // Update active state
        swatches.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        // Swap image with fade
        var newSrc = btn.dataset.img;
        var newAlt = btn.dataset.alt;
        if (newSrc) {
          configImg.style.opacity = '0';
          setTimeout(function () {
            configImg.src = newSrc;
            if (newAlt) configImg.alt = newAlt;
            configImg.style.opacity = '1';
          }, 150);
        }

        // Update label
        if (colorLbl && btn.dataset.label) {
          colorLbl.textContent = btn.dataset.label;
        }

        // Update Shopify variant ID
        if (variantId && btn.dataset.variantId) {
          variantId.value = btn.dataset.variantId;
        }
      });
    });
  }

  // ── Cart form feedback ─────────────────────────────────────
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var addBtn = productForm.querySelector('[name="add"]');
      if (addBtn) {
        addBtn.disabled  = true;
        addBtn.textContent = 'Ajout en cours…';
      }
      // Shopify handles the actual cart submission;
      // re-enable on error (Shopify fires 'cart:error' or page reloads on success)
      setTimeout(function () {
        if (addBtn) {
          addBtn.disabled    = false;
          addBtn.textContent = 'Ajouter au panier';
        }
      }, 3000);
    });
  }

})();
